module.exports = __webpack_public_path__ + "img/partially.8ddc0b40.svg";